// extracted by mini-css-extract-plugin
export var leftSide = "menuLinkContent-module--leftSide--94831";
export var white = "menuLinkContent-module--white--4951f";
export var wrapper = "menuLinkContent-module--wrapper--3d587";